import Gamepad from '@FreeRider/Utils/Gamepad';
import Vehicle from '@FreeRider/Player/Vehicles/Vehicle';
import MountainBike from '@FreeRider/Player/Vehicles/MountainBike';
import Track from '@FreeRider/Track';
import EventEmitter from '@Utils/Events/EventEmitter';
import Head from '@FreeRider/Player/Heads/Head';
import ForwardCap from '@FreeRider/Player/Heads/ForwardCap';
import ObjectExport from '@Utils/Object/Export';
import Powerup from '@FreeRider/Track/Powerups/Powerup';
import Extend from '@Utils/Object/Extend';


/**
 * Player
 */
class Player
{
    public gamepad: Gamepad;
    public vehicle: Vehicle;
    public isAlive: boolean;
    public head: Head;
    public powerupsConsumed: string[];
    private checkpointHit: boolean;

    /**
     * Construtor
     * @param game
     */
    constructor()
    {
        this.gamepad = new Gamepad();
        this.vehicle = new MountainBike(this);
        this.head = new ForwardCap();
        this.isAlive = true;
        this.checkpointHit = false;
        this.powerupsConsumed = [];
    }

    /**
     * Resets the player
     */
    public reset()
    {
        this.isAlive = true;
        this.powerupsConsumed = [];
        this.gamepad.reset();
        this.vehicle.reset();
    }

    /**
     * Updates player
     * @param track
     */
    public update(track: Track)
    {
        this.gamepad.update();
        this.vehicle.update(track);
        this.checkForCheckpoint();
    }

    /**
     * Check for checkpoint
     */
    private checkForCheckpoint()
    {
        if (this.checkpointHit)
        {
            EventEmitter.emit('player', 'checkpoint', this.export());
            this.checkpointHit = false;
        }
    }

    /**
     * Sets the player to not alive
     */
    public dead()
    {
        this.isAlive = false;
        EventEmitter.emit('player', 'dead');
    }

    /**
     * Sets checkpoint
     */
    public setCheckpoint()
    {
        this.checkpointHit = true;
    }

    /**
     * Exports player into a simple object
     */
    public export(): FreeRider.PlayerExported
    {
        const masses = ObjectExport(this.vehicle.masses, ['parent']) as object[];

        const powerupsConsumed = this.powerupsConsumed.slice(0);

        return {
            vehicle: {
                masses
             },
            powerupsConsumed
        };
    }

    /**
     * Imports player from simple object
     * @param playerImported
     */
    public import(playerImported: FreeRider.PlayerExported)
    {
        Extend(this, playerImported);
        this.isAlive = true;
    }

    /**
     * Adds powerup id to powerups consumed
     * @param powerup
     */
    public addConsumedPowerup(powerup: Powerup)
    {
        this.powerupsConsumed.push(powerup.id);
    }

    /**
     * Has consumed powerup
     * @param powerup
     */
    public hasConsumedPowerup(powerup: Powerup)
    {
        return this.powerupsConsumed.indexOf(powerup.id) !== -1;
    }
}

export default Player;